var map = {
	"./en-CA/checkout.json": "763a",
	"./en-CA/menu.json": "b03d",
	"./en-CA/profile.json": "fbd9",
	"./en-CA/utils.json": "6570",
	"./fr-CA/checkout.json": "0441",
	"./fr-CA/menu.json": "aaae",
	"./fr-CA/profile.json": "3155",
	"./fr-CA/utils.json": "2e8f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";